import {useLocale} from '#imports';

export function currenciesHelper() {
    function formatPrice(price: number) {
        const {locale} = useLocale();

        let currency = 'EUR';
        if (locale.value === 'en-GB') {
            currency = 'GBP';
        } else if (locale.value === 'en-AE') {
            currency = 'USD';
        }

        const formatter = new Intl.NumberFormat(locale.value, {style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0});
        return formatter.format(price);
    }

    return {formatPrice};
}
